import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Refresher, App, PopoverController } from 'ionic-angular';
import { ToastProvider } from '../../providers/toast/toast';
import { VehicleProvider } from '../../providers/vehicle/vehicle';
import { VehicleDetailPage } from '../vehicle-detail/vehicle-detail';
import { AddVehiclePage } from '../../pages/add-vehicle/add-vehicle';
import { LoginProvider } from '../../providers/login/login';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-my-vehicle',
  templateUrl: 'my-vehicle.html',
})
export class MyVehiclePage {

  permissions = false;
  showData = false;
  presentVehicle=[];
  absentVehicle=[];
  status : any;
  providers : any;
  vehicles = [];
  
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
    private vehicleProvider: VehicleProvider, 
    private toast: ToastProvider,
    private popOverCtrl: PopoverController,
    private login: LoginProvider,
    private app: App,)
    {
  	vehicleProvider.getVehiclesDetail().then(val => {
      if(val.status == "success"){
        this.vehicles = val.data;
        this.showData = true;
        console.log(val.data);
      } else {
        this.vehicles=[];
        this.showData=true;
        this.toast.presentToast(val.message);
      }
    });
    vehicleProvider.getTagsetup().then(val => {
      if(val.status == "success"){
        this.providers = val.data;
        console.log(this.providers);
      } else {
        this.providers = null;
      }
    });

    login.getUserDetails().then(val => {
      this.permissions = val.permissions;
    });
  }    

  doRefresh(Refresher){
  	this.vehicleProvider.getVehiclesDetail().then(val => {
      if(val.status == "success"){
        this.vehicles = val.data;
        this.showData = true;
        console.log(val.data);
      }
      else{
        this.vehicles=[];
        this.toast.presentToast(val.message);
      }
      setTimeout(() => {
        Refresher.complete();
      });
    });
  }

  refreshVehicle(){
  	this.vehicleProvider.getVehiclesDetail().then(val => {
      if(val.status == "success"){
        this.vehicles = val.data;
        this.showData = true;
        console.log(val.data);
      }
      else{
        this.vehicles=[];
        this.toast.presentToast(val.message);
      }
    });
  }

  vehicleDetail(vehicle: any){
    if(vehicle.is_approved == 1){
      this.app.getRootNav().push(VehicleDetailPage, {
        parent: this,
        data: vehicle,
        setup: this.providers
      });
    }else{
      this.navCtrl.push(AddVehiclePage, {
        parent : this,
        data: vehicle,
        providers: this.providers
      });
    }
    console.log(vehicle)
  }
  
  addVehicle(){
    this.navCtrl.push(AddVehiclePage, {
      parent : this,
      providers: this.providers
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MyVehiclePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/my-vehicle/my-vehicle.ts